import { useQuery } from "@apollo/client/react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ContactDocument } from "@/gql/graphql";
import { useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

const SEVENIT_CONTACTS: TTDict<string, string> = {
  sevdesk: "4802964",
  service: "348202",
};

type PropsType = {
  contactChosen: (cnt: ContactRefType) => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const SevenItAdditionalButtons = ({ contactChosen }: PropsType) => {
  const session = useAppSelector(sessionSelector);
  const { t } = useTranslation(["acd"]);

  const { data } = useQuery(ContactDocument, {
    variables: {
      customerId: session.currentCustomer.id,
      projectId: session.currentProject.id,
      id: SEVENIT_CONTACTS[session.currentProject.identifier] || "",
    },
    skip: !SEVENIT_CONTACTS[session.currentProject.identifier],
  });

  const contact = data?.contact;

  if (!contact) return null;

  return (
    <Button variant="secondary" onClick={() => contactChosen(contact)}>
      {t("acd:incoming_call.no_ident")}
    </Button>
  );
};

export const ADDITIONAL_BUTTONS: TTDict<string, TTDict<string, React.ComponentType<PropsType>>> = {
  "sevenit-gmbh": {
    sevdesk: SevenItAdditionalButtons,
    service: SevenItAdditionalButtons,
  },
};
